<template>
  <div>
    <QueryFrame
      :disablePage="disablePage"
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>起止时间:</label>
            <timeStampDatePicker type="daterange" placeholder="请选择" v-model="query.date"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-tabs type="card" v-model="noticeType" @on-click="handleNoticeTypeClick">
          <lk-tab-pane label="新公告" name="1">
          </lk-tab-pane>
          <lk-tab-pane label="历史公告" name="2">
          </lk-tab-pane>
        </lk-tabs>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'codeTable',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    hasEdit() {
      return this.handlePermission('noticeCheck');
    },
  },
  data() {
    return {
      query: {
        date: null,
      },
      noticeType: '1',
      disablePage: true,
      columns: [
        {
          title: '业务流水号',
          key: 'serialNo',
          minWidth: 116,
        },
        {
          title: '公告内容',
          key: 'content',
          minWidth: 116,
        },
        {
          title: '经办人',
          key: 'handleUser',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '经办日期',
          key: 'handleDate',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '操作',
          key: 'action',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: (row.status === 1 || this.noticeType === '2'), //  是否确认 1是 2否 && 历史页面确认禁用
              },
              on: {
                click: () => {
                  this.handleConfirm(row);
                },
              },
            }, '确认'),
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    getData() {
      if (this.noticeType === '2') {
        this.params.page = this.page;
        this.params.size = this.size;
      }
      if (this.params.date && this.params.date.length === 2) {
      	this.params.startTime = this.params.date[0];
        this.params.endTime = this.params.date[1];
      }
      delete this.params.date;

      const finalAction = this.noticeType === '1' ? insurance.getNewNoticeList : insurance.getMiNoticeList;
      this.tableData = [];
      finalAction(this.params).then((res) => {
        if (res.data.status === 200) {
          if (this.noticeType === '1') {
            this.disablePage = true;
            const data = res.data.data;
            data.forEach((item) => {
            	item.handleDate = utils.formatDate(item.handleDate);
            });
            this.tableData = data;
          } else {
            const { count, list } = res.data.data;
            list.forEach((item) => {
              item.handleDate = utils.formatDate(item.handleDate);
            });
            this.count = count;
            this.tableData = list;
            this.disablePage = false;
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleNoticeTypeClick() {
      this.getData();
    },
    handleConfirm(row) {
    	const params = utils.deepClone(row);
      delete params._index;
    	delete params._rowKey;
      insurance.noticeCheck(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('确认成功');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.handleSearch(true);

    // 没有编辑权限，移除操作列
    if (!this.hasEdit) {
      this.columns.pop();
    }
  },
};
</script>
<style lang="less" scoped>
</style>
